import { useGetNewApplicationQuery } from "../../store/api/generated/stock-request-api";
import { isNullish } from "../../lib/util/common-util";
import { useMemo } from "react";
import {
  newApplicationMeta,
  NewApplicationSaved,
} from "../../lib/object/entity/new-application";

export function useAppGetNewApplicationQuery(
  arg: Parameters<typeof useGetNewApplicationQuery>[0],
  options?: Parameters<typeof useGetNewApplicationQuery>[1],
  skipOptionalValidations = true, // get系は、skipOptionalValidationsのデフォルトはtrueとする。
): {
  data: NewApplicationSaved | null;
  currentData: NewApplicationSaved | null;
  isLoading: ReturnType<typeof useGetNewApplicationQuery>["isLoading"];
  refetch: ReturnType<typeof useGetNewApplicationQuery>["refetch"];
  error: ReturnType<typeof useGetNewApplicationQuery>["error"];
} {
  const {
    data: rawData,
    currentData: rawCurrentData,
    isLoading,
    refetch,
    error,
  } = useGetNewApplicationQuery(arg, options);

  const data = useMemo(() => {
    if (isNullish(rawData)) return null;
    return newApplicationMeta.toSavedDomainObjectOrNull(
      rawData,
      skipOptionalValidations,
    );
  }, [rawData, skipOptionalValidations]);
  const currentData = useMemo(() => {
    if (isNullish(rawCurrentData)) return null;
    return newApplicationMeta.toSavedDomainObjectOrNull(
      rawCurrentData,
      skipOptionalValidations,
    );
  }, [rawCurrentData, skipOptionalValidations]);

  return { data, currentData, isLoading, refetch, error };
}
